import React from 'react';
import Link from 'next/link';
import { AvilaIcon, LinkedinIcon } from '@avila-tek/ui/src';
import logo from '../../public/images/logo-meit-blanco.png';

const links = [
  { label: 'Términos y condiciones', href: 'terms-and-conditions' },
  { label: 'Preguntas frecuentes', href: 'frequently-asked-question' },
];

function Footer() {
  return (
    <div className="w-full bg-color-primary-300 flex flex-col">
      <div className=" md:p-10 p-2 flex md:flex-row flex-col justify-between gap-y-8">
        <div className="md:w-1/4 flex flex-col gap-y-2 justify-center items-center border-red-600">
          <div className="relative w-full mt-10 md:mt-0 h-[5vh] md:h-[40%]">
            <div className="absolute top-[50%] right-[50%] transform translate-x-1/2 md:translate-x-0 -translate-y-[60%] flex flex-col justify-start items-start">
              <h1 className="font-title font-semibold text-xs text-white">
                Powered by
              </h1>
              <img
                alt="Footer logo"
                src={logo.src}
                className="object-cover scale-125"
              />
            </div>
          </div>
          <div className="mt-2">
            <p className="font-text text-white lg:text-sm text-xs w-100 pl-0">
              Sistematizamos los planes de beneficios e incentivos de tu
              empresa.
            </p>
          </div>
        </div>
        <div className="md:w-1/4 w-full flex flex-col gap-y-2 ml-5 lg:ml-48 lg:pl-8">
          <p className="font-title font-semibold text-base text-white  pb-1.5">
            Explora
          </p>
          <div className="flex flex-col gap-y-1">
            <Link href="/">
              <div className="font-title font-medium lg:text-sm text-xs hover:underline text-white">
                Inicio
              </div>
            </Link>
            <Link href="/sections">
              <div className="font-title font-medium lg:text-sm text-xs hover:underline text-white">
                Catálogo
              </div>
            </Link>
            <Link
              href={`${process.env.NEXT_PUBLIC_DASHBOARD_URL}/sign-in/ally`}
              target="_blank"
            >
              <div className="font-title font-medium lg:text-sm text-xs hover:underline text-white">
                Conviértete en nuestro aliado
              </div>
            </Link>
            <Link
              href={`${process.env.NEXT_PUBLIC_DASHBOARD_URL}/sign-in/company`}
              target="_blank"
            >
              <div className="font-title font-medium lg:text-sm text-xs hover:underline text-white">
                Impulsa tus beneficiarios
              </div>
            </Link>
          </div>
        </div>
        <div className="md:w-1/4 w-full flex flex-col gap-y-2 pl-5 lg:pl-20">
          <p className="font-title font-semibold text-base text-white pb-1.5">
            Recursos
          </p>
          <div className="flex flex-col gap-y-1">
            {links.map((i, index) => (
              <Link href={`${i.href}`} key={index}>
                <div className="font-title font-medium lg:text-sm text-xs hover:underline text-white">
                  {i.label}
                </div>
              </Link>
            ))}
          </div>
        </div>
        <div className="md:w-1/4 w-full flex md:flex-col flex-row pl-5">
          <div className="gap-y-2 flex flex-col md:w-full w-1/2">
            <p className="font-title font-semibold text-base text-white  pb-1.5">
              Contáctanos
            </p>

            <div className="flex flex-col gap-y-1">
              <div className="flex flex-col gap-y-1">
                <Link
                  href="https://calendly.com/carlos-meit/meit"
                  target="_blank"
                >
                  <div className="font-title font-medium lg:text-sm text-xs hover:underline text-white">
                    Agenda un demo con nosotros
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex md:flex-row flex-col justify-between lg:px-10 lg:mb-3 px-5 pb-2">
        <div className="flex flex-row gap-x-2 items-center group">
          <Link href="https://avilatek.com">
            <div className="text-white lg:text-sm md:text-sm text-xs">
              © Momentos Magix, LLC. Todos los derechos reservados. Desarrollado
              por Avila Tek
            </div>
          </Link>
          <Link href="https://avilatek.com" target="_blank">
            <AvilaIcon className="w-8 text-white" />
          </Link>
        </div>
        <div className="flex md:flex-row flex-col justify-between lg:px-10 lg:mb-3 px-5 pb-2 mt-5">
          <Link
            href="https://www.linkedin.com/company/pidemeit/people/?viewAsMember=true"
            target="_blank"
          >
            <LinkedinIcon className="flex justify-center text-cold-500 w-6" />
          </Link>
        </div>
      </div>
      <div className="bg-color-secondary-200  w-screen h-2" />
    </div>
  );
}
export default Footer;
